import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { buildSentryIOOptions } from '@asamco/application-link/shared';
import * as Sentry from '@sentry/angular';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();
}

const sentryOptions = {environment: 'ApplicationLink'};
if(window.location.hostname.includes('localhost')) {
	sentryOptions.environment += ' Development';
} else if(window.location.href.startsWith('https://applicationlink-test.azurewebsites.net')) {
	sentryOptions.environment += ' Test';
} else if(window.location.href.startsWith('https://applicationlink-ua.azurewebsites.net')) {
	sentryOptions.environment += ' User-Acceptance';
} else {
	sentryOptions.environment += ' Production';
}

Sentry.init(buildSentryIOOptions(sentryOptions));

bootstrapApplication(AppComponent, appConfig).catch(e => {
	console.error(e);
});
